<form class="report-filters" [formGroup]="form">
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-calendar formControlName="dateFrom" [placeholder]="'Start Date'" [iconDisplay]="'input'"
                [showIcon]="true"></p-calendar>
        </span>
    </div>
    <div class="controls-wrapper">
        <span class="p-input-icon-right">
            <p-calendar formControlName="dateTo" [placeholder]="'End Date'" [iconDisplay]="'input'"
                [showIcon]="true"></p-calendar>
        </span>
    </div>
    <div class="controls-wrapper button-wrapper">
        <p-button label="Search" [text]="true" [raised]="true" severity="success" [disabled]="form.invalid"
            (onClick)="submit()" class="report-action-button" icon="pi pi-search"></p-button>
        <p-button label="Export" [text]="true" [raised]="true" (onClick)="export()"
            severity="success" class="report-action-button" icon="pi pi-download"></p-button>
    </div>
</form>
<hr />
<div class="table-container">
    <p-table #reportTable [value]="reports" [scrollable]="true"
        scrollHeight="400px" styleClass="p-datatable-striped" [tableStyle]="{ 'min-width': '50rem' }"
        responsiveLayout="stack" [breakpoint]="'768px'">
        <ng-template pTemplate="header">
            <tr>
                <th>Purchaser Name</th>
                <th>Purchaser Surname</th>
                <th>Trip Origin</th>
                <th>Departure Date</th>
                <th>Destination</th>
                <th>Arrival Date</th>
                <th>Return Origin</th>
                <th>Return Departure</th>
                <th>Return Destination</th>
                <th>Return Arrival</th>
                <th>Plan</th>
                <th>Passengers</th>
                <th>Per Passenger Amount</th>
                <th>Total</th>
                <th>Currency</th>
                <th>Reference</th>
                <th>Policy Status</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-report>
            <tr>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Purchaser Name</span>
                    {{ report["purchaser"] ? report["purchaser"]["firstName"] : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Purchaser Surname</span>
                    {{ report["purchaser"] ? report["purchaser"]["lastName"] : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Trip Origin</span>
                    {{ report["trip"] ? report["trip"]["origin"] : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Departure Date</span>
                    {{ report["trip"] ? (report["trip"]["departAt"] | date:'medium') : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Destination</span>
                    {{ report["trip"] ? report["trip"]["destination"] : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Arrival Date</span>
                    {{ report["trip"] ? (report["trip"]["arriveAt"] | date:'medium') : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Return Origin</span>
                    {{ report["trip"]["returnOrigin"] ? report["trip"]["returnOrigin"] : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Return Departure</span>
                    {{ report["trip"]["returnDepartAt"] ? (report["trip"]["returnDepartAt"] | date:'medium') : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Return Destination</span>
                    {{ report["trip"]["returnDestination"] ? report["trip"]["returnDestination"] : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Return Arrival</span>
                    {{ report["trip"]["returnArriveAt"] ? (report["trip"]["returnArriveAt"] | date:'medium') : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Plan</span>
                    {{ report["insurance"]["plan"] ? report["insurance"]["plan"] : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Passengers</span>
                    {{ report["passengers"] ? report["passengers"].length : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Per Passenger Amount</span>
                    {{ report["insurance"]["perPassenger"] ? (report["insurance"]["perPassenger"] | currency) : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Total</span>
                    {{ report["insurance"]["total"] ? (report["insurance"]["total"] | currency:'USD') : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Currency</span>
                    {{ report["insurance"]["currency"] ? report["insurance"]["currency"] : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Reference</span>
                    {{ report["reference"] ? report["reference"] : "---" }}
                </td>
                <td style="width: 25%; min-width: 7rem">
                    <span class="p-column-title">Policy Status</span>
                    {{ report["status"] }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
